import React, { useState, useEffect, useRef } from "react";
import Logo from "../images/whitelogo.png";
import userlogo from "../images/user.png";
import { getAuth, signOut } from "firebase/auth";
import { Link, useNavigate } from "react-router-dom";
import { useStateValue } from "../context/StateProvider";
import { actionType } from "../context/reducer";
import { BiMenu } from "react-icons/bi";
import { IoIosClose } from "react-icons/io";
import { FiSettings, FiLogOut } from "react-icons/fi";
import SignInPopup from "./Signinpopup";
import { getToken } from "firebase/messaging";
import { messaging } from "./../../firebase.config";
import { updateItem } from "../../utils/firebasefunctions";
import NotificationBell from "./Notifications";
import "./index.css";

const Header = () => {
  const auth = getAuth();
  const navigate = useNavigate();
  const [{ user }, dispatch] = useStateValue();
  const [isMenu, setisMenu] = useState(false);
  const [userpopup, setuserpopup] = useState(false);
  const [currentPopup, setCurrentPopup] = useState("");

  const isLoginRoute = window.location.pathname === "/login";
  const isHomeRoute = window.location.pathname === "/home";

  const userpopupref = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        userpopupref.current &&
        !userpopupref.current.contains(event.target)
      ) {
        setuserpopup(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [userpopupref]);

  const handleNext = (popupName) => {
    setCurrentPopup(popupName);
  };

  const handleClose = () => {
    setCurrentPopup(null);
  };

  const renderPopup = () => {
    switch (currentPopup) {
      case "signin":
        return (
          <SignInPopup
            name={currentPopup}
            onClose={handleClose}
            onNext={handleNext}
          />
        );
      default:
        return null;
    }
  };

  const signout = async () => {
    signOut(auth)
      .then(() => {
        dispatch({
          type: actionType.SET_USER,
          payload: [],
        });
        setuserpopup(false);
        navigate("/");
      })
      .catch((error) => {
        alert("sign out error");
      });
  };

  // async function requestPermission() {
  //   const permission = await Notification.requestPermission();
  //   if (permission === "granted") {
  //     const token = await getToken(messaging, {
  //       vapidKey:
  //         "BBb7l_frsXySelNGhOBb5H1qNI7jOb5qdqpivVz2CPiw3sc9nfg6EW4Ub6oSUPOCbH52Q6TOejfZTExlxHovnCc",
  //     });

  //     if (
  //       user?.NotificationToken != undefined &&
  //       user?.NotificationToken?.find((item) => item == token) != undefined
  //     ) {
  //       let data = [...user.NotificationToken];
  //       data = data.filter((item) => item != token);

  //       let dataset = {
  //         NotificationToken: data,
  //       };

  //       await updateItem("users", user?.id, dataset)
  //         .then(async () => {
  //           signout();
  //         })
  //         .catch((err) => {
  //           alert(err);
  //         });
  //     } else {
  //       signout();
  //     }
  //   } else if (permission === "denied") {
  //     signout();
  //   }
  // }

  const requestPermission = async () => {
    try {
      if (typeof Notification === "undefined" || !("Notification" in window)) {
        // Notification API not supported on this browser — just sign out
        signout();
        return;
      }

      const permission = await Notification.requestPermission();

      if (permission === "granted") {
        try {
          const token = await getToken(messaging, {
            vapidKey:
              "BBb7l_frsXySelNGhOBb5H1qNI7jOb5qdqpivVz2CPiw3sc9nfg6EW4Ub6oSUPOCbH52Q6TOejfZTExlxHovnCc",
          });

          if (
            user?.NotificationToken != undefined &&
            user?.NotificationToken?.find((item) => item == token) != undefined
          ) {
            let data = [...user.NotificationToken];
            data = data.filter((item) => item != token);

            await updateItem("users", user?.id, { NotificationToken: data });
          }
        } catch (tokenErr) {
          console.warn("Could not fetch/remove notification token:", tokenErr);
          // fall through to signout regardless
        }
      }

      // covers "granted", "denied", AND "default" — always sign out
      signout();
    } catch (err) {
      console.warn("Notification permission flow failed:", err);
      signout(); // never let this block sign out
    }
  };

  const editprofile = () => {
    navigate("/dashboard", {
      state: {
        employeedata: user,
      },
    });
    setuserpopup(false);
  };

  return (
    <div className="relative ">
      <header className="fixed z-50 w-screen">
        {/* Desktop Header */}
        {(!isHomeRoute && !isLoginRoute) ||
        (user?.usertype != "SuperAdmin" &&
          user?.usertype != "Admin" &&
          user?.usertype != "Supervisor" &&
          !isLoginRoute) ? (
          <div className="hidden md:flex w-full h-full bg-themelightblack shadow-md border-b border-white/10 items-center justify-between px-8 py-3">
            <div
              className="cursor-pointer"
              onClick={() => {
                dispatch({
                  type: actionType.STORE_SELECTED_TILE,
                  payload: "Dashboard",
                });
                navigate("/home");
              }}
            >
              <img
                loading="lazy"
                src={Logo}
                className="w-[150px] h-[40px] object-contain"
                alt="logo"
              />
            </div>

            <div className="flex items-center space-x-6 pt-1">
              {user?.usertype == "Admin" ||
              user?.usertype == "SuperAdmin" ||
              user?.usertype == "Supervisor" ? (
                <Link to={"/employees"}>
                  <p className="navheadingstyle PoppinsRegular text-sm text-white/80 hover:text-white transition-colors">
                    Employees
                  </p>
                </Link>
              ) : null}

              {user?.usertype == "Supervisor" ? (
                <div
                  className="cursor-pointer"
                  onClick={() => {
                    dispatch({
                      type: actionType.STORE_SELECTED_TILE,
                      payload: "Slots",
                    });
                    navigate("/home");
                  }}
                >
                  <p className="navheadingstyle PoppinsRegular text-sm text-white/80 hover:text-white transition-colors">
                    Slots
                  </p>
                </div>
              ) : null}

              {user?.usertype == "Admin" || user?.usertype == "SuperAdmin" ? (
                <div
                  className="cursor-pointer"
                  onClick={() => {
                    dispatch({
                      type: actionType.STORE_SELECTED_TILE,
                      payload: "Create User",
                    });
                    navigate("/home");
                  }}
                >
                  <p className="navheadingstyle PoppinsRegular text-sm text-white/80 hover:text-white transition-colors">
                    Create User
                  </p>
                </div>
              ) : null}

              {user?.usertype == "Admin" || user?.usertype == "SuperAdmin" ? (
                <div
                  className="cursor-pointer"
                  onClick={() => {
                    dispatch({
                      type: actionType.STORE_SELECTED_TILE,
                      payload: "Leave Request",
                    });
                    navigate("/home");
                  }}
                >
                  <p className="navheadingstyle PoppinsRegular text-sm text-white/80 hover:text-white transition-colors">
                    Leave Request
                  </p>
                </div>
              ) : null}

              {user?.usertype == "Admin" || user?.usertype == "SuperAdmin" ? (
                <div
                  className="cursor-pointer"
                  onClick={() => {
                    dispatch({
                      type: actionType.STORE_SELECTED_TILE,
                      payload: "Vehicle",
                    });
                    navigate("/home");
                  }}
                >
                  <p className="navheadingstyle PoppinsRegular text-sm text-white/80 hover:text-white transition-colors">
                    Vehicle
                  </p>
                </div>
              ) : null}

              {user?.usertype == "Supervisor" && user?.clientrole != true ? (
                <div
                  className="cursor-pointer"
                  onClick={() => {
                    dispatch({
                      type: actionType.STORE_SELECTED_TILE,
                      payload: "To Do List",
                    });
                    navigate("/home");
                  }}
                >
                  <p className="navheadingstyle PoppinsRegular text-sm text-white/80 hover:text-white transition-colors">
                    To Do List
                  </p>
                </div>
              ) : null}

              {user?.usertype == "Admin" || user?.usertype == "SuperAdmin" ? (
                <div
                  className="cursor-pointer"
                  onClick={() => {
                    dispatch({
                      type: actionType.STORE_SELECTED_TILE,
                      payload: "Create Project",
                    });
                    navigate("/home");
                  }}
                >
                  <p className="navheadingstyle PoppinsRegular text-sm text-white/80 hover:text-white transition-colors">
                    Create Project
                  </p>
                </div>
              ) : null}

              {user?.usertype == "Project" ? (
                <Link to={"/CreateEmployeeSchedule"}>
                  <p className="navheadingstyle PoppinsRegular text-sm text-white/80 hover:text-white transition-colors">
                    Employee Schedule
                  </p>
                </Link>
              ) : null}

              {user?.usertype == "Admin" || user?.usertype == "SuperAdmin" ? (
                <div
                  className="cursor-pointer"
                  onClick={() => {
                    dispatch({
                      type: actionType.STORE_SELECTED_TILE,
                      payload: "Assign Project",
                    });
                    navigate("/home");
                  }}
                >
                  <p className="navheadingstyle PoppinsRegular text-sm text-white/80 hover:text-white transition-colors">
                    Assign Project
                  </p>
                </div>
              ) : null}

              {user?.usertype == "Admin" || user?.usertype == "SuperAdmin" ? (
                <div
                  className="cursor-pointer"
                  onClick={() => {
                    dispatch({
                      type: actionType.STORE_SELECTED_TILE,
                      payload: "Assign Vehicle",
                    });
                    navigate("/home");
                  }}
                >
                  <p className="navheadingstyle PoppinsRegular text-sm text-white/80 hover:text-white transition-colors">
                    Assign Vehicle
                  </p>
                </div>
              ) : null}

              {user?.usertype == "Project" ? (
                <Link to={"/ProjectDesignations"}>
                  <p className="navheadingstyle PoppinsRegular text-sm text-white/80 hover:text-white transition-colors">
                    Project Designations
                  </p>
                </Link>
              ) : null}

              {user?.usertype == "Admin" ||
              user?.usertype == "Employee" ||
              user?.usertype == "SuperAdmin" ? (
                <Link to={"/Messages"}>
                  <p className="navheadingstyle PoppinsRegular text-sm text-white/80 hover:text-white transition-colors">
                    Support
                  </p>
                </Link>
              ) : null}

              <div
                className="cursor-pointer"
                onClick={() => {
                  if (user?.usertype == "Project") {
                    navigate("/Blogs");
                  } else {
                    dispatch({
                      type: actionType.STORE_SELECTED_TILE,
                      payload: "Blogs",
                    });
                    navigate("/home");
                  }
                }}
              >
                <p className="navheadingstyle PoppinsRegular text-sm text-white/80 hover:text-white transition-colors">
                  Blogs
                </p>
              </div>
            </div>

            <div className="flex items-center space-x-3">
              <NotificationBell />
              <div
                onClick={() => setuserpopup(!userpopup)}
                className="relative cursor-pointer"
              >
                <img
                  loading="lazy"
                  src={
                    user?.profilepicture
                      ? user?.profilepicture
                      : user?.logo
                        ? user?.logo
                        : userlogo
                  }
                  className="w-[40px] h-[40px] object-cover rounded-full border border-white/20 shadow-sm"
                  alt="User Profile"
                />
              </div>
            </div>
          </div>
        ) : null}

        {/* Mobile Header */}
        {!isLoginRoute && (
          <div className="flex items-center bg-themelightblack shadow-md border-b border-white/10 md:hidden w-full h-full px-4 py-3 justify-between">
            <div className="flex items-center space-x-3">
              <BiMenu
                onClick={() => setisMenu(true)}
                className="text-white text-[28px] cursor-pointer hover:opacity-80"
              />
              <div
                className="cursor-pointer"
                onClick={() => {
                  dispatch({
                    type: actionType.STORE_SELECTED_TILE,
                    payload: "Dashboard",
                  });
                  navigate("/home");
                }}
              >
                <img
                  loading="lazy"
                  src={Logo}
                  className="w-[120px] object-contain"
                  alt="logo"
                />
              </div>
            </div>

            <div className="flex items-center space-x-3">
              <NotificationBell />
              <div onClick={() => setuserpopup(!userpopup)}>
                <img
                  loading="lazy"
                  src={
                    user?.profilepicture
                      ? user?.profilepicture
                      : user?.logo
                        ? user?.logo
                        : userlogo
                  }
                  className="w-[35px] h-[35px] object-cover rounded-full border border-white/20 cursor-pointer"
                  alt="User Profile"
                />
              </div>
            </div>
          </div>
        )}
      </header>

      {/* Mobile Slide-in Menu Drawer */}
      {isMenu && (
        <div className="fixed inset-0 z-50 bg-black/60 backdrop-blur-sm flex flex-col md:hidden animate-fadeIn">
          <div className="bg-themelightblack h-full w-[80%] max-w-[300px] shadow-2xl flex flex-col p-5 border-r border-white/10">
            <div className="flex items-center justify-between pb-4 border-b border-white/10">
              <img
                loading="lazy"
                src={Logo}
                className="w-[120px] object-contain"
                alt="logo"
              />
              <IoIosClose
                onClick={() => setisMenu(false)}
                className="text-white text-[32px] cursor-pointer hover:opacity-80"
              />
            </div>

            <div className="flex flex-col space-y-2 mt-5 overflow-y-auto pr-1">
              {user?.usertype == "Admin" ||
              user?.usertype == "SuperAdmin" ||
              user?.usertype == "Supervisor" ? (
                <Link
                  to={"/employees"}
                  onClick={() => setisMenu(false)}
                  className="px-3 py-2.5 rounded-lg hover:bg-themeblue text-white text-sm font-medium transition-colors"
                >
                  Employees
                </Link>
              ) : null}

              {user?.usertype == "Admin" || user?.usertype == "SuperAdmin" ? (
                <div
                  onClick={() => {
                    dispatch({
                      type: actionType.STORE_SELECTED_TILE,
                      payload: "Create User",
                    });
                    navigate("/home");
                    setisMenu(false);
                  }}
                  className="px-3 py-2.5 rounded-lg hover:bg-themeblue text-white text-sm font-medium cursor-pointer transition-colors"
                >
                  Create User
                </div>
              ) : null}

              {user?.usertype == "Project" ? (
                <Link
                  to={"/CreateEmployeeSchedule"}
                  onClick={() => setisMenu(false)}
                  className="px-3 py-2.5 rounded-lg hover:bg-themeblue text-white text-sm font-medium transition-colors"
                >
                  Employee Schedule
                </Link>
              ) : null}

              {user?.usertype == "Admin" || user?.usertype == "SuperAdmin" ? (
                <div
                  onClick={() => {
                    dispatch({
                      type: actionType.STORE_SELECTED_TILE,
                      payload: "Assign Project",
                    });
                    navigate("/home");
                    setisMenu(false);
                  }}
                  className="px-3 py-2.5 rounded-lg hover:bg-themeblue text-white text-sm font-medium cursor-pointer transition-colors"
                >
                  Assign Project
                </div>
              ) : null}

              {user?.usertype == "Admin" || user?.usertype == "SuperAdmin" ? (
                <div
                  onClick={() => {
                    dispatch({
                      type: actionType.STORE_SELECTED_TILE,
                      payload: "Assign Vehicle",
                    });
                    navigate("/home");
                    setisMenu(false);
                  }}
                  className="px-3 py-2.5 rounded-lg hover:bg-themeblue text-white text-sm font-medium cursor-pointer transition-colors"
                >
                  Assign Vehicle
                </div>
              ) : null}

              {user?.usertype == "Project" ? (
                <Link
                  to={"/ProjectDesignations"}
                  onClick={() => setisMenu(false)}
                  className="px-3 py-2.5 rounded-lg hover:bg-themeblue text-white text-sm font-medium transition-colors"
                >
                  Project Designations
                </Link>
              ) : null}

              {user?.usertype == "Admin" || user?.usertype == "SuperAdmin" ? (
                <div
                  onClick={() => {
                    dispatch({
                      type: actionType.STORE_SELECTED_TILE,
                      payload: "Leave Request",
                    });
                    navigate("/home");
                    setisMenu(false);
                  }}
                  className="px-3 py-2.5 rounded-lg hover:bg-themeblue text-white text-sm font-medium cursor-pointer transition-colors"
                >
                  Leave Request
                </div>
              ) : null}

              {user?.usertype == "Admin" ||
              user?.usertype == "SuperAdmin" ||
              (user?.usertype == "Supervisor" && user?.clientrole != true) ? (
                <div
                  onClick={() => {
                    dispatch({
                      type: actionType.STORE_SELECTED_TILE,
                      payload: "Vehicle",
                    });
                    navigate("/home");
                    setisMenu(false);
                  }}
                  className="px-3 py-2.5 rounded-lg hover:bg-themeblue text-white text-sm font-medium cursor-pointer transition-colors"
                >
                  Vehicle
                </div>
              ) : null}

              {user?.usertype == "Supervisor" && user?.clientrole != true ? (
                <div
                  onClick={() => {
                    dispatch({
                      type: actionType.STORE_SELECTED_TILE,
                      payload: "To Do List",
                    });
                    navigate("/home");
                    setisMenu(false);
                  }}
                  className="px-3 py-2.5 rounded-lg hover:bg-themeblue text-white text-sm font-medium cursor-pointer transition-colors"
                >
                  To Do List
                </div>
              ) : null}

              {user?.usertype == "Admin" || user?.usertype == "SuperAdmin" ? (
                <div
                  onClick={() => {
                    dispatch({
                      type: actionType.STORE_SELECTED_TILE,
                      payload: "Create Project",
                    });
                    navigate("/home");
                    setisMenu(false);
                  }}
                  className="px-3 py-2.5 rounded-lg hover:bg-themeblue text-white text-sm font-medium cursor-pointer transition-colors"
                >
                  Create Project
                </div>
              ) : null}

              {user?.usertype == "Admin" ||
              user?.usertype == "Employee" ||
              user?.usertype == "SuperAdmin" ? (
                <Link
                  to={"/Messages"}
                  onClick={() => setisMenu(false)}
                  className="px-3 py-2.5 rounded-lg hover:bg-themeblue text-white text-sm font-medium transition-colors"
                >
                  Support
                </Link>
              ) : null}

              <div
                onClick={() => {
                  if (user?.usertype == "Project") {
                    navigate("/Blogs");
                  } else {
                    dispatch({
                      type: actionType.STORE_SELECTED_TILE,
                      payload: "Blogs",
                    });
                    navigate("/home");
                  }
                  setisMenu(false);
                }}
                className="px-3 py-2.5 rounded-lg hover:bg-themeblue text-white text-sm font-medium cursor-pointer transition-colors"
              >
                Blogs
              </div>

              {user?.usertype == "Supervisor" && (
                <div
                  onClick={() => {
                    dispatch({
                      type: actionType.STORE_SELECTED_TILE,
                      payload: "Slots",
                    });
                    navigate("/home");
                    setisMenu(false);
                  }}
                  className="px-3 py-2.5 rounded-lg hover:bg-themeblue text-white text-sm font-medium cursor-pointer transition-colors"
                >
                  Slots
                </div>
              )}
            </div>
          </div>
          <div className="flex-1" onClick={() => setisMenu(false)}></div>
        </div>
      )}

      {/* Redesigned User Profile Popup Modal */}
      {userpopup && (
        <div
          ref={userpopupref}
          className="bg-themelightblack border border-white/10 w-[240px] fixed z-50 right-6 top-[65px] rounded-2xl shadow-2xl flex flex-col items-center py-5 px-4 animate-fadeIn"
        >
          <img
            loading="lazy"
            src={
              user?.profilepicture
                ? user?.profilepicture
                : user?.logo
                  ? user?.logo
                  : userlogo
            }
            className="w-[55px] h-[55px] object-cover rounded-full border border-white/20 shadow-md"
            alt="User"
          />
          <p className="text-white PoppinsRegular font-medium text-sm mt-3 text-center truncate w-full">
            {user?.usertype == "Project"
              ? user?.name
              : user?.usertype == "Project"
                ? user?.title
                : `${user?.firstname || ""} ${user?.lastname || ""}`}
          </p>
          <span className="bg-white/10 text-lightgrey PoppinsRegular text-[10px] px-2 py-0.5 rounded-full mt-1 uppercase tracking-wider">
            {user?.clientrole ? "Client" : user?.usertype}
          </span>

          <div className="mt-4 w-full border-t border-white/10 pt-3 space-y-1">
            {user?.usertype != "Project" && (
              <div
                className="flex items-center w-full px-3 py-2 rounded-lg hover:bg-white/5 cursor-pointer transition-colors text-white text-xs"
                onClick={() => editprofile()}
              >
                <FiSettings size={16} className="text-white/70 mr-2.5" />
                <span className="PoppinsRegular font-medium">Settings</span>
              </div>
            )}
            <div
              className="flex items-center w-full px-3 py-2 rounded-lg hover:bg-red-500/10 text-red-400 cursor-pointer transition-colors text-xs"
              onClick={() => requestPermission()}
            >
              <FiLogOut size={16} className="mr-2.5" />
              <span className="PoppinsRegular font-medium">Log Out</span>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Header;
